import React from "react";
import "./ServicesOverview.css";

const ServicesOverview = () => {
  const cardsData = [
    {
      title: "Medical services",
      value: "1,218",
      subtitle: "delivered this period",
    },
    {
      title: "Non-medical services",
      value: "0",
      subtitle: "see data alert below",
    },
    {
      title: "Top service by revenue",
      value: "Abdominal Cryptorchid Neutering - M",
      subtitle: "₹8.7L this period",
    },
    {
      title: "Service line items (period)",
      value: "550",
      subtitle: "across all appointments",
    },
  ];

  return (
    <div className="services-overview-container">
      <h2 className="services-overview-title">Services overview</h2>
      <div className="services-overview-cards-grid">
        {cardsData.map((card, index) => (
          <div className="services-overview-card" key={index}>
            <h4 className="services-overview-card-title">{card.title}</h4>
            <div className="services-overview-card-value-container">
              <h2 className="services-overview-card-value">{card.value}</h2>
            </div>
            <div className="services-overview-card-subtitle">
              {card.subtitle}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesOverview;
